module.exports = __webpack_public_path__ + "static/media/background-6.00ea542d.jpg";